import { HttpErrorResponse } from '@angular/common/http';
import { ActionCompletion } from '@ngxs/store';
import { AppError } from '../errors/app-error';

export const extractHttpErrorResponse = (
  actionCompletion: ActionCompletion,
): HttpErrorResponse['error'] => {
  const resultError = actionCompletion.result.error;

  return ((resultError as AppError).originalError as HttpErrorResponse).error;
};
